import user1 from "@/assets/images/users/user-1.jpg"
import user2 from "@/assets/images/users/user-2.jpg"
import user3 from "@/assets/images/users/user-3.jpg"
import user4 from "@/assets/images/users/user-4.jpg"
import user5 from "@/assets/images/users/user-5.jpg"
import user6 from "@/assets/images/users/user-6.jpg"
export const basiTableData = [
  {
    id: 1,
    age: 82,
    first_name: "Dorelle",
    last_name: "Harling",
    email: "dharling0@rediff.com",
    gender: "Female",
    phone: "232(152)707-0110",
    ccupation: "Financial Advisor",
    img: user1,
  },
  {
    id: 2,
    age: 89,
    first_name: "Bendicty",
    last_name: "Llewellin",
    email: "bllewellin1@example.com",
    gender: "Male",
    phone: "420(169)218-1769",
    ccupation: "Marketing Assistant",
    img: user2,
  },
  {
    id: 3,
    age: 28,
    first_name: "Remy",
    last_name: "Carbry",
    email: "rcarbry2@prlog.org",
    gender: "Polygender",
    phone: "86(958)204-4491",
    ccupation: "Mechanical Systems Engineer",
    img: user3,
  },
  {
    id: 4,
    age: 20,
    first_name: "Bernardo",
    last_name: "Hacun",
    email: "bhacun3@xinhuanet.com",
    gender: "Male",
    phone: "86(974)709-5254",
    ccupation: "Research Assistant IV",
    img: user4,
  },
  {
    id: 5,
    age: 2,
    first_name: "Emelia",
    last_name: "Garstang",
    email: "egarstang4@miitbeian.gov.cn",
    gender: "Female",
    phone: "55(644)175-6748",
    ccupation: "Business Systems Development Analyst",
    img: user5,
  },
  {
    id: 6,
    age: 98,
    first_name: "Dian",
    last_name: "Dopson",
    email: "ddopson5@examiner.com",
    gender: "Female",
    phone: "51(186)560-8480",
    ccupation: "Cost Accountant",
    img: user6,
  },
  {
    id: 7,
    age: 17,
    first_name: "Coretta",
    last_name: "Ponter",
    email: "cponter6@loc.gov",
    gender: "Female",
    phone: "1(941)734-6255",
    ccupation: "Budget/Accounting Analyst II",
    img: user1,
  },
  {
    id: 8,
    age: 85,
    first_name: "Valentine",
    last_name: "Crispin",
    email: "vcrispin7@dailymotion.com",
    gender: "Male",
    phone: "380(627)884-8734",
    ccupation: "Project Manager",
    img: user2,
  },
  {
    id: 9,
    age: 77,
    first_name: "Gill",
    last_name: "Sutlieff",
    email: "gsutlieff8@engadget.com",
    gender: "Male",
    phone: "386(374)937-6305",
    ccupation: "Recruiter",
    img: user3,
  },
  {
    id: 10,
    age: 23,
    first_name: "Noreen",
    last_name: "Blick",
    email: "nblick9@usa.gov",
    gender: "Female",
    phone: "998(884)893-6477",
    ccupation: "Human Resources Manager",
    img: user4,
  },
  {
    id: 11,
    age: 2,
    first_name: "Noll",
    last_name: "Doniso",
    email: "ndonisoa@dropbox.com",
    gender: "Male",
    phone: "62(891)114-3443",
    ccupation: "General Manager",
    img: user5,
  },
  {
    id: 12,
    age: 3,
    first_name: "Edvard",
    last_name: "Espinas",
    email: "eespinasb@over-blog.com",
    gender: "Male",
    phone: "62(564)280-1360",
    ccupation: "Senior Financial Analyst",
    img: user6,
  },
  {
    id: 13,
    age: 66,
    first_name: "Nicolis",
    last_name: "Aglione",
    email: "naglionec@epa.gov",
    gender: "Male",
    phone: "57(354)171-9855",
    ccupation: "Senior Financial Analyst",
    img: user1,
  },
  {
    id: 14,
    age: 2,
    first_name: "Natalee",
    last_name: "Mabbs",
    email: "nmabbsd@elegantthemes.com",
    gender: "Female",
    phone: "63(963)373-2874",
    ccupation: "Operator",
    img: user2,
  },
  {
    id: 15,
    age: 95,
    first_name: "Uri",
    last_name: "Bramford",
    email: "ubramforde@seesaa.net",
    gender: "Male",
    phone: "55(546)435-7304",
    ccupation: "Programmer II",
    img: user3,
  },
  {
    id: 16,
    age: 58,
    first_name: "Emmy",
    last_name: "Garm",
    email: "egarmf@engadget.com",
    gender: "Female",
    phone: "591(180)907-2249",
    ccupation: "Account Executive",
    img: user4,
  },
  {
    id: 17,
    age: 86,
    first_name: "Hoyt",
    last_name: "Runnalls",
    email: "hrunnallsg@dailymotion.com",
    gender: "Male",
    phone: "30(515)278-6344",
    ccupation: "Budget/Accounting Analyst II",
    img: user5,
  },
  {
    id: 18,
    age: 60,
    first_name: "Marillin",
    last_name: "Maryet",
    email: "mmaryeth@dagondesign.com",
    gender: "Female",
    phone: "27(660)562-5635",
    ccupation: "Junior Executive",
    img: user6,
  },
  {
    id: 19,
    age: 16,
    first_name: "Raddy",
    last_name: "Cretney",
    email: "rcretneyi@cmu.edu",
    gender: "Male",
    phone: "374(646)574-6654",
    ccupation: "Chemical Engineer",
    img: user1,
  },
  {
    id: 20,
    age: 42,
    first_name: "Decca",
    last_name: "Narup",
    email: "dnarupj@dagondesign.com",
    gender: "Male",
    phone: "7(964)301-2278",
    ccupation: "Nurse Practicioner",
    img: user2,
  },
  {
    id: 21,
    age: 27,
    first_name: "Orion",
    last_name: "Dunne",
    email: "odunnek@cnbc.com",
    gender: "Male",
    phone: "1(910)450-9780",
    ccupation: "Data Coordiator",
    img: user3,
  },
  {
    id: 22,
    age: 47,
    first_name: "Jeanie",
    last_name: "Nozzolii",
    email: "jnozzoliil@stumbleupon.com",
    gender: "Female",
    phone: "62(567)910-7256",
    ccupation: "Registered Nurse",
    img: user4,
  },
  {
    id: 23,
    age: 72,
    first_name: "Norah",
    last_name: "Grivori",
    email: "ngrivorim@delicious.com",
    gender: "Female",
    phone: "7(870)757-4318",
    ccupation: "Sales Representative",
    img: user5,
  },
  {
    id: 24,
    age: 89,
    first_name: "Massimiliano",
    last_name: "Snodden",
    email: "msnoddenn@ucoz.ru",
    gender: "Male",
    phone: "82(582)574-1970",
    ccupation: "Recruiter",
    img: user6,
  },
  {
    id: 25,
    age: 62,
    first_name: "Glori",
    last_name: "Nannoni",
    email: "gnannonio@ihg.com",
    gender: "Female",
    phone: "48(356)235-7306",
    ccupation: "Senior Sales Associate",
    img: user1,
  },
  {
    id: 26,
    age: 23,
    first_name: "Karly",
    last_name: "Janous",
    email: "kjanousp@liveinternet.ru",
    gender: "Female",
    phone: "33(312)747-9116",
    ccupation: "Speech Pathologist",
    img: user2,
  },
  {
    id: 27,
    age: 100,
    first_name: "Hugibert",
    last_name: "MacAllester",
    email: "hmacallesterq@constantcontact.com",
    gender: "Male",
    phone: "62(416)665-0619",
    ccupation: "Account Coordinator",
    img: user3,
  },
  {
    id: 28,
    age: 85,
    first_name: "Marlow",
    last_name: "Munsey",
    email: "mmunseyr@spiegel.de",
    gender: "Male",
    phone: "967(713)722-9345",
    ccupation: "Senior Editor",
    img: user4,
  },
  {
    id: 29,
    age: 39,
    first_name: "Tuckie",
    last_name: "Inwood",
    email: "tinwoods@alexa.com",
    gender: "Male",
    phone: "998(291)785-1422",
    ccupation: "Paralegal",
    img: user5,
  },
  {
    id: 30,
    age: 59,
    first_name: "Krishna",
    last_name: "Ovendale",
    email: "kovendalet@telegraph.co.uk",
    gender: "Male",
    phone: "81(977)473-0581",
    ccupation: "Environmental Specialist",
    img: user6,
  },
  {
    id: 31,
    age: 43,
    first_name: "Wolf",
    last_name: "Vannah",
    email: "wvannahu@godaddy.com",
    gender: "Male",
    phone: "48(938)552-5576",
    ccupation: "Financial Analyst",
    img: user1,
  },
  {
    id: 32,
    age: 33,
    first_name: "Levy",
    last_name: "Staresmeare",
    email: "lstaresmearev@eventbrite.com",
    gender: "Male",
    phone: "66(971)191-0397",
    ccupation: "Biostatistician IV",
    img: user2,
  },
  {
    id: 33,
    age: 30,
    first_name: "Odell",
    last_name: "Minero",
    email: "ominerow@irs.gov",
    gender: "Male",
    phone: "62(187)718-2690",
    ccupation: "Director of Sales",
    img: user3,
  },
  {
    id: 34,
    age: 16,
    first_name: "Gaston",
    last_name: "Rudgley",
    email: "grudgleyx@mozilla.com",
    gender: "Male",
    phone: "54(491)426-6076",
    ccupation: "Chief Design Engineer",
    img: user4,
  },
  {
    id: 35,
    age: 55,
    first_name: "Wain",
    last_name: "Renac",
    email: "wrenacy@illinois.edu",
    gender: "Male",
    phone: "7(719)471-4771",
    ccupation: "Database Administrator I",
    img: user5,
  },
  {
    id: 36,
    age: 46,
    first_name: "Timmie",
    last_name: "Robotham",
    email: "trobothamz@xing.com",
    gender: "Male",
    phone: "63(132)653-1655",
    ccupation: "Recruiting Manager",
    img: user6,
  },
  {
    id: 37,
    age: 33,
    first_name: "Windham",
    last_name: "Dudman",
    email: "wdudman10@smh.com.au",
    gender: "Male",
    phone: "86(695)839-0433",
    ccupation: "Senior Financial Analyst",
    img: user1,
  },
  {
    id: 38,
    age: 74,
    first_name: "Allene",
    last_name: "Noury",
    email: "anoury11@soup.io",
    gender: "Female",
    phone: "351(222)474-2030",
    ccupation: "Research Associate",
    img: user2,
  },
  {
    id: 39,
    age: 16,
    first_name: "Cornie",
    last_name: "Rozec",
    email: "crozec12@howstuffworks.com",
    gender: "Male",
    phone: "380(481)480-8282",
    ccupation: "Chief Design Engineer",
    img: user3,
  },
  {
    id: 40,
    age: 44,
    first_name: "Jeremie",
    last_name: "Thynne",
    email: "jthynne13@zdnet.com",
    gender: "Male",
    phone: "251(966)881-4028",
    ccupation: "Analog Circuit Design manager",
    img: user4,
  },
  {
    id: 41,
    age: 59,
    first_name: "Erda",
    last_name: "Frayne",
    email: "efrayne14@moonfruit.com",
    gender: "Female",
    phone: "86(502)895-4971",
    ccupation: "Biostatistician I",
    img: user5,
  },
  {
    id: 42,
    age: 20,
    first_name: "Giulietta",
    last_name: "Serrels",
    email: "gserrels15@pbs.org",
    gender: "Female",
    phone: "86(626)869-8255",
    ccupation: "Social Worker",
    img: user6,
  },
  {
    id: 43,
    age: 3,
    first_name: "Shaylah",
    last_name: "Symones",
    email: "ssymones16@indiegogo.com",
    gender: "Female",
    phone: "353(823)187-8422",
    ccupation: "Administrative Assistant I",
    img: user1,
  },
  {
    id: 44,
    age: 40,
    first_name: "Thorvald",
    last_name: "Robjant",
    email: "trobjant17@mapy.cz",
    gender: "Male",
    phone: "66(792)606-7511",
    ccupation: "Mechanical Systems Engineer",
    img: user2,
  },
  {
    id: 45,
    age: 41,
    first_name: "Pauletta",
    last_name: "Horsewood",
    email: "phorsewood18@yahoo.co.jp",
    gender: "Female",
    phone: "62(413)578-6139",
    ccupation: "Legal Assistant",
    img: user3,
  },
  {
    id: 46,
    age: 21,
    first_name: "Adan",
    last_name: "Nardrup",
    email: "anardrup19@discovery.com",
    gender: "Female",
    phone: "7(731)243-8504",
    ccupation: "Office Assistant IV",
    img: user4,
  },
  {
    id: 47,
    age: 94,
    first_name: "Cleopatra",
    last_name: "Robens",
    email: "crobens1a@bluehost.com",
    gender: "Female",
    phone: "86(468)199-8951",
    ccupation: "Biostatistician I",
    img: user5,
  },
  {
    id: 48,
    age: 19,
    first_name: "Guillemette",
    last_name: "Gehring",
    email: "ggehring1b@exblog.jp",
    gender: "Female",
    phone: "385(277)272-7058",
    ccupation: "Account Representative IV",
    img: user6,
  },
  {
    id: 49,
    age: 51,
    first_name: "Leora",
    last_name: "Maudling",
    email: "lmaudling1c@topsy.com",
    gender: "Female",
    phone: "54(565)109-8803",
    ccupation: "Physical Therapy Assistant",
    img: user1,
  },
  {
    id: 50,
    age: 51,
    first_name: "Leora",
    last_name: "Maudling",
    email: "lmaudling1c@topsy.com",
    gender: "Female",
    phone: "54(565)109-8803",
    ccupation: "Physical Therapy Assistant",
    img: user2,
  },
];

import customer1 from "@/assets/images/all-img/customer_1.png"
export const advancedTable = [
  {
    id: 1,
    order: 951,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "3/26/2022",
    quantity: 13,
    amount: "$1779.53",
    status: "paid",
    action: null,
  },
  {
    id: 2,
    order: 238,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "2/6/2022",
    quantity: 13,
    amount: "$2215.78",
    status: "due",
    action: null,
  },
  {
    id: 3,
    order: 339,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "9/6/2021",
    quantity: 1,
    amount: "$3183.60",
    status: "due",
    action: null,
  },
  {
    id: 4,
    order: 365,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "11/7/2021",
    quantity: 13,
    amount: "$2587.86",
    status: "cancled",
    action: null,
  },
  {
    id: 5,
    order: 513,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "5/6/2022",
    quantity: 12,
    amount: "$3840.73",
    status: "paid",
    action: null,
  },
  {
    id: 6,
    order: 534,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "2/14/2022",
    quantity: 12,
    amount: "$4764.18",
    status: "cancled",
    action: null,
  },
  {
    id: 7,
    order: 77,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "7/30/2022",
    quantity: 6,
    amount: "$2875.05",
    status: "paid",
    action: null,
  },
  {
    id: 8,
    order: 238,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "6/30/2022",
    quantity: 9,
    amount: "$2491.02",
    status: "due",
    action: null,
  },
  {
    id: 9,
    order: 886,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "8/9/2022",
    quantity: 8,
    amount: "$3006.95",
    status: "due",
    action: null,
  },
  {
    id: 10,
    order: 3,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "8/4/2022",
    quantity: 12,
    amount: "$2160.32",
    status: "paid",
    action: null,
  },
  {
    id: 11,
    order: 198,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "4/5/2022",
    quantity: 8,
    amount: "$1272.66",
    status: "paid",
    action: null,
  },
  {
    id: 12,
    order: 829,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "8/9/2022",
    quantity: 2,
    amount: "$4327.86",
    status: "cancled",
    action: null,
  },
  {
    id: 13,
    order: 595,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "2/10/2022",
    quantity: 11,
    amount: "$3671.81",
    status: "cancled",
    action: null,
  },
  {
    id: 14,
    order: 374,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "2/10/2022",
    quantity: 2,
    amount: "$3401.82",
    status: "paid",
    action: null,
  },
  {
    id: 15,
    order: 32,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "5/20/2022",
    quantity: 4,
    amount: "$2387.49",
    status: "cancled",
    action: null,
  },
  {
    id: 16,
    order: 89,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "5/3/2022",
    quantity: 15,
    amount: "$4236.61",
    status: "due",
    action: null,
  },
  {
    id: 17,
    order: 912,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "10/31/2021",
    quantity: 11,
    amount: "$2975.66",
    status: "paid",
    action: null,
  },
  {
    id: 18,
    order: 621,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "1/13/2022",
    quantity: 5,
    amount: "$4576.13",
    status: "cancled",
    action: null,
  },
  {
    id: 19,
    order: 459,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "6/14/2022",
    quantity: 5,
    amount: "$1276.56",
    status: "cancled",
    action: null,
  },
  {
    id: 20,
    order: 108,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "10/8/2021",
    quantity: 4,
    amount: "$1078.64",
    status: "due",
    action: null,
  },
  {
    id: 21,
    order: 492,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "11/17/2021",
    quantity: 9,
    amount: "$1678.19",
    status: "paid",
    action: null,
  },
  {
    id: 22,
    order: 42,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "4/4/2022",
    quantity: 9,
    amount: "$1822.02",
    status: "cancled",
    action: null,
  },
  {
    id: 23,
    order: 841,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "3/21/2022",
    quantity: 5,
    amount: "$1578.39",
    status: "due",
    action: null,
  },
  {
    id: 24,
    order: 561,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "6/18/2022",
    quantity: 12,
    amount: "$2130.49",
    status: "cancled",
    action: null,
  },
  {
    id: 25,
    order: 720,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "8/15/2022",
    quantity: 8,
    amount: "$3721.11",
    status: "due",
    action: null,
  },
  {
    id: 26,
    order: 309,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "4/28/2022",
    quantity: 8,
    amount: "$4683.45",
    status: "paid",
    action: null,
  },
  {
    id: 27,
    order: 24,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "9/6/2021",
    quantity: 7,
    amount: "$2863.71",
    status: "paid",
    action: null,
  },
  {
    id: 28,
    order: 518,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "9/11/2021",
    quantity: 4,
    amount: "$3879.41",
    status: "cancled",
    action: null,
  },
  {
    id: 29,
    order: 98,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "1/27/2022",
    quantity: 5,
    amount: "$4660.81",
    status: "paid",
    action: null,
  },
  {
    id: 30,
    order: 940,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "9/16/2021",
    quantity: 6,
    amount: "$4800.75",
    status: "due",
    action: null,
  },
  {
    id: 31,
    order: 925,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "1/8/2022",
    quantity: 1,
    amount: "$2299.05",
    status: "cancled",
    action: null,
  },
  {
    id: 32,
    order: 122,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "11/18/2021",
    quantity: 1,
    amount: "$3578.02",
    status: "paid",
    action: null,
  },
  {
    id: 33,
    order: 371,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "3/30/2022",
    quantity: 13,
    amount: "$1996.06",
    status: "cancled",
    action: null,
  },
  {
    id: 34,
    order: 296,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "11/13/2021",
    quantity: 5,
    amount: "$2749.00",
    status: "due",
    action: null,
  },
  {
    id: 35,
    order: 887,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "12/7/2021",
    quantity: 11,
    amount: "$4353.01",
    status: "paid",
    action: null,
  },
  {
    id: 36,
    order: 30,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "9/9/2021",
    quantity: 15,
    amount: "$3252.37",
    status: "due",
    action: null,
  },
  {
    id: 37,
    order: 365,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "2/12/2022",
    quantity: 5,
    amount: "$4044.10",
    status: "due",
    action: null,
  },
  {
    id: 38,
    order: 649,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "3/6/2022",
    quantity: 5,
    amount: "$3859.92",
    status: "paid",
    action: null,
  },
  {
    id: 39,
    order: 923,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "7/25/2022",
    quantity: 14,
    amount: "$1652.47",
    status: "paid",
    action: null,
  },
  {
    id: 40,
    order: 423,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "3/2/2022",
    quantity: 8,
    amount: "$2700.12",
    status: "cancled",
    action: null,
  },
  {
    id: 41,
    order: 703,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "12/8/2021",
    quantity: 8,
    amount: "$4508.13",
    status: "cancled",
    action: null,
  },
  {
    id: 42,
    order: 792,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "11/22/2021",
    quantity: 11,
    amount: "$4938.04",
    status: "due",
    action: null,
  },
  {
    id: 43,
    order: 400,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "4/6/2022",
    quantity: 1,
    amount: "$3471.32",
    status: "due",
    action: null,
  },
  {
    id: 44,
    order: 718,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "2/4/2022",
    quantity: 4,
    amount: "$4011.60",
    status: "paid",
    action: null,
  },
  {
    id: 45,
    order: 970,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "3/30/2022",
    quantity: 15,
    amount: "$3723.64",
    status: "due",
    action: null,
  },
  {
    id: 46,
    order: 786,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "11/20/2021",
    quantity: 2,
    amount: "$2441.15",
    status: "cancled",
    action: null,
  },
  {
    id: 47,
    order: 925,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "10/24/2021",
    quantity: 11,
    amount: "$1196.76",
    status: "cancled",
    action: null,
  },
  {
    id: 48,
    order: 929,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "6/30/2022",
    quantity: 10,
    amount: "$3579.57",
    status: "cancled",
    action: null,
  },
  {
    id: 49,
    order: 377,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "11/16/2021",
    quantity: 4,
    amount: "$2657.84",
    status: "due",
    action: null,
  },
  {
    id: 50,
    order: 661,
    customer: {
      name: "Jenny Wilson",
      image: customer1,
    },
    date: "8/15/2022",
    quantity: 6,
    amount: "$2905.94",
    status: "paid",
    action: null,
  },
];

export const homeTable = [
  {
    company: user1,
    category: "Ornamental Railings",
    views: 343,
    revenue: "$231.26",
    sales: 95,
    up: false,
  },
  {
    company: user2,
    category: "Asphalt Paving",
    views: 315,
    revenue: "$432.81",
    sales: 197,
    up: false,
  },
  {
    company: user3,
    category: "Framing (Steel)",
    views: 329,
    revenue: "$437.65",
    sales: 137,
    up: true,
  },
  {
    company: user4,
    category: "Structural and Misc Steel (Fabrication)",
    views: 336,
    revenue: "$387.55",
    sales: 101,
    up: true,
  },
  {
    company: user5,
    category: "Wall Protection",
    views: 375,
    revenue: "$489.80",
    sales: 99,
    up: false,
  },
  {
    company: user6,
    category: "Marlite Panels (FED)",
    views: 490,
    revenue: "$421.45",
    sales: 101,
    up: true,
  },
  {
    company: user1,
    category: "Epoxy Flooring",
    views: 433,
    revenue: "$207.61",
    sales: 197,
    up: false,
  },
  {
    company: user2,
    category: "Epoxy Flooring",
    views: 499,
    revenue: "$392.86",
    sales: 91,
    up: false,
  },
  {
    company: user3,
    category: "Marlite Panels (FED)",
    views: 441,
    revenue: "$162.87",
    sales: 115,
    up: false,
  },
  {
    company: user4,
    category: "RF Shielding",
    views: 415,
    revenue: "$268.58",
    sales: 128,
    up: false,
  },
  {
    company: user5,
    category: "Roofing (Metal)",
    views: 303,
    revenue: "$369.19",
    sales: 179,
    up: false,
  },
  {
    company: user6,
    category: "RF Shielding",
    views: 415,
    revenue: "$420.87",
    sales: 148,
    up: false,
  },
  {
    company: user1,
    category: "Curb & Gutter",
    views: 493,
    revenue: "$420.26",
    sales: 152,
    up: false,
  },
  {
    company: user2,
    category: "Structural & Misc Steel Erection",
    views: 498,
    revenue: "$228.41",
    sales: 151,
    up: false,
  },
  {
    company: user3,
    category: "Retaining Wall and Brick Pavers",
    views: 465,
    revenue: "$140.83",
    sales: 71,
    up: false,
  },
  {
    company: user4,
    category: "Sitework & Site Utilities",
    views: 468,
    revenue: "$475.63",
    sales: 114,
    up: false,
  },
  {
    company: user5,
    category: "Framing (Steel)",
    views: 357,
    revenue: "$415.37",
    sales: 163,
    up: false,
  },
  {
    company: user6,
    category: "Waterproofing & Caulking",
    views: 487,
    revenue: "$436.53",
    sales: 170,
    up: false,
  },
  {
    company: user1,
    category: "Site Furnishings",
    views: 357,
    revenue: "$147.36",
    sales: 71,
    up: false,
  },
  {
    company: user2,
    category: "Casework",
    views: 465,
    revenue: "$121.67",
    sales: 78,
    up: false,
  },
  {
    company: user3,
    category: "Ornamental Railings",
    views: 438,
    revenue: "$213.25",
    sales: 155,
    up: false,
  },
  {
    company: user4,
    category: "Waterproofing & Caulking",
    views: 461,
    revenue: "$186.48",
    sales: 137,
    up: false,
  },
  {
    company: user5,
    category: "Masonry",
    views: 423,
    revenue: "$130.97",
    sales: 178,
    up: false,
  },
  {
    company: user6,
    category: "Curb & Gutter",
    views: 339,
    revenue: "$255.69",
    sales: 101,
    up: false,
  },
  {
    company: user1,
    category: "HVAC",
    views: 361,
    revenue: "$484.64",
    sales: 175,
    up: true,
  },
  {
    company: user2,
    category: "Exterior Signage",
    views: 353,
    revenue: "$485.51",
    sales: 176,
    up: true,
  },
  {
    company: user3,
    category: "Fire Protection",
    views: 364,
    revenue: "$449.45",
    sales: 136,
    up: true,
  },
  {
    company: user4,
    category: "Rebar & Wire Mesh Install",
    views: 493,
    revenue: "$309.61",
    sales: 163,
    up: true,
  },
  {
    company: user5,
    category: "Temp Fencing, Decorative Fencing and Gates",
    views: 393,
    revenue: "$372.45",
    sales: 180,
    up: true,
  },
  {
    company: user6,
    category: "Fire Protection",
    views: 441,
    revenue: "$470.34",
    sales: 104,
    up: false,
  },
];

export const recetOrder = [
  {
    user: {
      name: "Esther Howard",
      image: user1,
    },
    product: "Headphone",
    invoice: "#324567",
    price: "$90.99",
    status: "paid",
  },
  {
    user: {
      name: "Guy Hawkins",
      image: user2,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$78.65",
    status: "due",
  },
  {
    user: {
      name: "Bessie Cooper",
      image: user3,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$78.65",
    status: "pending",
  },
  {
    user: {
      name: "Kathryn Murphy",
      image: user4,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$38.65",
    status: "cancled",
  },
  {
    user: {
      name: "Darrell Steward",
      image: user5,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$178.65",
    status: "shipped",
  },
  {
    user: {
      name: "Darrell Steward",
      image: user6,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$74.65",
    status: "cancled",
  },
  {
    user: {
      name: "Esther Howard",
      image: user1,
    },
    product: "Headphone",
    invoice: "#324567",
    price: "$90.99",
    status: "paid",
  },
  {
    user: {
      name: "Guy Hawkins",
      image: user2,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$78.65",
    status: "due",
  },
  {
    user: {
      name: "Bessie Cooper",
      image: user3,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$78.65",
    status: "pending",
  },
  {
    user: {
      name: "Kathryn Murphy",
      image: user4,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$38.65",
    status: "cancled",
  },
  {
    user: {
      name: "Darrell Steward",
      image: user5,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$178.65",
    status: "shipped",
  },
  {
    user: {
      name: "Darrell Steward",
      image: user6,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$74.65",
    status: "cancled",
  },
  {
    user: {
      name: "Esther Howard",
      image: user1,
    },
    product: "Headphone",
    invoice: "#324567",
    price: "$90.99",
    status: "paid",
  },
  {
    user: {
      name: "Guy Hawkins",
      image: user2,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$78.65",
    status: "due",
  },
  {
    user: {
      name: "Bessie Cooper",
      image: user3,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$78.65",
    status: "pending",
  },
  {
    user: {
      name: "Kathryn Murphy",
      image: user4,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$38.65",
    status: "cancled",
  },
  {
    user: {
      name: "Darrell Steward",
      image: user5,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$178.65",
    status: "shipped",
  },
  {
    user: {
      name: "Darrell Steward",
      image: user6,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$74.65",
    status: "cancled",
  },
  {
    user: {
      name: "Esther Howard",
      image: user1,
    },
    product: "Headphone",
    invoice: "#324567",
    price: "$90.99",
    status: "paid",
  },
  {
    user: {
      name: "Guy Hawkins",
      image: user2,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$78.65",
    status: "due",
  },
  {
    user: {
      name: "Bessie Cooper",
      image: user3,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$78.65",
    status: "pending",
  },
  {
    user: {
      name: "Kathryn Murphy",
      image: user4,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$38.65",
    status: "cancled",
  },
  {
    user: {
      name: "Darrell Steward",
      image: user5,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$178.65",
    status: "shipped",
  },
  {
    user: {
      name: "Darrell Steward",
      image: user6,
    },
    product: "Headphone",
    invoice: "#4224",
    price: "$74.65",
    status: "cancled",
  },
];
